import { Box, FormControl, FormLabel, TextField } from "@mui/material";
import React from "react";
import Position from "../../../../types/Position";
import { CreatableAutocomplete } from "../shared/CustomCreatableAutocomplete";

interface NameAndPositionSectionProps {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  position: Position;
  setPosition: React.Dispatch<React.SetStateAction<Position>>;
  setProfessionalSummary: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  errors: Record<string, string>;
  removeErrorMessage: (field: string) => void;
  isEditMode: boolean;
  role: "User" | "Admin" | null;
  positions: Position[];
  addPosition: (title: string) => Promise<Position>;
}

export const NameAndPositionSection: React.FC<NameAndPositionSectionProps> = ({
  name,
  setName,
  position,
  setPosition,
  email,
  setEmail,
  setProfessionalSummary,
  removeErrorMessage,
  errors,
  isEditMode,
  role,
  positions,
  addPosition,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr",
          gap: "2rem",
        }}
      >
        <FormControl>
          <FormLabel htmlFor="name">Name And Surname</FormLabel>
          <TextField
            value={name}
            id="name"
            type="text"
            name="name"
            error={!!errors.name}
            helperText={errors.name}
            placeholder="Name And Surname"
            required
            onChange={(e) => {
              removeErrorMessage("name");
              setName(e.target.value);
            }}
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "50px",
                boxSizing: "border-box",
              },
            }}
            variant="outlined"
            color={"primary"}
          />
        </FormControl>
        <CreatableAutocomplete
          options={positions}
          value={
            positions.find((p) => p.positionId === position.positionId) ?? null
          }
          title="Positions"
          getLabel={(p) => p.name}
          getId={(p) => p.positionId}
          onCreate={addPosition}
          onChange={(pos) => {
            if (!pos) {
              // user clicked the X (clear)
              setPosition({ positionId: "", name: "", summary: "" });
              if (!isEditMode) setProfessionalSummary("");
              return;
            }
            removeErrorMessage("position");
            setPosition(pos);
            if (!isEditMode) setProfessionalSummary(pos.summary ?? "");
          }}
          placeholder="Type or Select Position"
          error={!!errors.position}
          helperText={errors.position}
        />
      </Box>
      {!isEditMode && role === "Admin" && (
        <FormControl>
          <FormLabel htmlFor="email">Email</FormLabel>
          <TextField
            value={email}
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            error={!!errors.email}
            helperText={errors.email}
            required
            onChange={(e) => {
              removeErrorMessage("email");
              setEmail(e.target.value);
            }}
            fullWidth
            variant="outlined"
            color={"primary"}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "50px",
                boxSizing: "border-box",
              },
            }}
          />
        </FormControl>
      )}
    </>
  );
};
